__turbopack_context__.v({
  "app_light_theme": "total-product-item-module-scss-module__-79ozq__app_light_theme",
  "totalProductItem": "total-product-item-module-scss-module__-79ozq__totalProductItem",
  "totalProductItem__price": "total-product-item-module-scss-module__-79ozq__totalProductItem__price",
  "totalProductItem__textWrap": "total-product-item-module-scss-module__-79ozq__totalProductItem__textWrap",
});
